import colors from '@/theme/constants/colors';
import {UspContentProps} from './typings';

export const uspContent: UspContentProps = [
  {
    icon: 'palette',
    background: colors.yellow25,
    children: (
      <>
        Shop authentic, <br />
        handmade art
      </>
    ),
  },
  {
    icon: 'profile',
    background: colors.red25,
    children: (
      <>
        Connect directly <br />
        with artists
      </>
    ),
  },
  {
    icon: 'shield',
    background: colors.skyBlue25,
    children: (
      <>
        Free global <br />
        returns
      </>
    ),
  },
  {
    image: `/img/v2/bcorp/bcorp_short.svg`,
    imageDescription: 'B Corp logo',
    children: (
      <>
        Proudly <br />B Corp certified
      </>
    ),
  },
];
